import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import itServicesData from './itServicesData';
import './ITEnquiry.css';

function ITEnquiry() {
  const { serviceId } = useParams();
  const service = itServicesData.find(item => item.id === serviceId);
  const serviceType = service ? service.title : 'IT Service';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    preferredStartDate: '',
    budget: '',
    projectDescription: '',
    additionalComments: '',
    serviceType: serviceType
  });
  
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSending, setIsSending] = useState(false);
  
  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
    setErrors({...errors, [e.target.name]: ''});
    setSubmitMessage('');
  };
  
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Full Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email.";
    }
    if (!formData.projectDescription.trim()) newErrors.projectDescription = "Project Description is required.";
    if (!formData.preferredStartDate) newErrors.preferredStartDate = "Preferred Start Date is required.";
    return newErrors;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if(Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSending(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/it-enquiry`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(formData)
      });
      const data = await response.json();
      if(response.ok) {
        setSubmitMessage("Thank you for your enquiry! We will get back to you within 24 hours.");
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          preferredStartDate: '',
          budget: '',
          projectDescription: '',
          additionalComments: '',
          serviceType: serviceType
        });
        setErrors({});
      } else {
        setSubmitMessage(data.error || "An error occurred.");
      }
    } catch(error) {
      console.error('Error sending enquiry:', error);
      setSubmitMessage("An error occurred while sending your enquiry. Please try again later.");
    }
    setIsSending(false);
  };
  
  return (
    <section className="it-enquiry-page">
      <div className="enquiry-container">
        <h1>Enquiry for {serviceType}</h1>
        <p>Please fill out the form below with your project details. We will get back to you within 24 hours.</p>
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label htmlFor="name">Full Name<span className="required">*</span></label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your full name" className={errors.name ? "error" : ""} />
            {errors.name && <small className="error-message">{errors.name}</small>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email<span className="required">*</span></label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" className={errors.email ? "error" : ""} />
            {errors.email && <small className="error-message">{errors.email}</small>}
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your contact number" />
          </div>
          <div className="form-group">
            <label htmlFor="company">Company/Organization</label>
            <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} placeholder="Your company or organization" />
          </div>
          <div className="form-group">
            <label htmlFor="preferredStartDate">Preferred Start Date<span className="required">*</span></label>
            <input type="date" id="preferredStartDate" name="preferredStartDate" value={formData.preferredStartDate} onChange={handleChange} className={errors.preferredStartDate ? "error" : ""} />
            {errors.preferredStartDate && <small className="error-message">{errors.preferredStartDate}</small>}
          </div>
          <div className="form-group">
            <label htmlFor="budget">Budget (optional)</label>
            <input type="number" id="budget" name="budget" value={formData.budget} onChange={handleChange} placeholder="Estimated budget" />
          </div>
          <div className="form-group">
            <label htmlFor="projectDescription">Project Description<span className="required">*</span></label>
            <textarea id="projectDescription" name="projectDescription" value={formData.projectDescription} onChange={handleChange} placeholder="Describe your project in detail" rows="4" className={errors.projectDescription ? "error" : ""}></textarea>
            {errors.projectDescription && <small className="error-message">{errors.projectDescription}</small>}
          </div>
          <div className="form-group">
            <label htmlFor="additionalComments">Additional Comments</label>
            <textarea id="additionalComments" name="additionalComments" value={formData.additionalComments} onChange={handleChange} placeholder="Any extra information or questions" rows="4"></textarea>
          </div>
          <button type="submit" className="submit-button" disabled={isSending}>
            {isSending ? "Sending..." : "Submit Enquiry"}
          </button>
          {submitMessage && <p className="submit-message">{submitMessage}</p>}
        </form>
        <Link to={`/it/${serviceId}`} className="back-button">← Back to IT Service Details</Link>
      </div>
    </section>
  );
}

export default ITEnquiry;
